import { useSetAtom } from "jotai";
import { merchflowNotesModalAtom, type MerchflowNotesModalData } from "./atoms";
import { useModals } from "src/components/Modals";
import { useEffect } from "react";

export const useMerchflowNotesModal = () => {
  const { openModal } = useModals();

  const setData = useSetAtom(merchflowNotesModalAtom);

  useEffect(() => {
    setData(null);
  }, []);

  const openMerchflowNotesModal = (data: MerchflowNotesModalData) => {
    setData(data);
    openModal("MerchflowNotesModal");
  };

  return { openMerchflowNotesModal };
};
